const isEmpty = (value) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  return false;
};

const smetaFields = ['salary', 'material', 'equipment', 'other', 'paper'];

const years = ['2025', '2026', '2027'];

const getTotalByYear = (coexecutorData, year) => {
  switch (year) {
    case '2025':
      return coexecutorData.step1Sum + coexecutorData.step2Sum;
    case '2026':
      return coexecutorData.step3Sum + coexecutorData.step4Sum;
    case '2027':
      return coexecutorData.step5Sum + coexecutorData.step6Sum;
    default:
      return 0;
  }
};

export const approveValidationCoexecutorsAgreement = (values, application, allData) => {
  let isError = false;
  const tabs = [
    { name: 'info', label: 'Краткие сведения о Грантополучателе для генерации Соглашения на предоставление гранта:', errorFields: [] },
    {
      name: 'bank', label: 'Банковские реквизиты Грантополучателя', errorFields: [],
    },
    { name: 'tz', label: 'Техническое задание на выполнение научно-исследовательских работ (НИР) и/или научно-исследовательских, опытно-конструкторских и технологических работ (НИОКР)', errorFields: [] },
    { name: 'plan', label: 'План-график исполнения обязательств:', errorFields: [] },
    { name: 'smeta', label: 'Смета:', errorFields: [] },
  ];

  // eslint-disable-next-line no-restricted-syntax
  for (const tab of tabs) {
    if (tab.name === 'info') {

      if (values?.directorFullNameRod.toLowerCase() === application?.directorFullName?.toLowerCase()) {
        isError = true;
        tab.errorFields.push('ФИО лица, уполномоченного на право подписи должно быть в родительном падеже');
      }

      if (!isEmpty(values.osnovanie) && !allData.osnovanieFile?.urlLink) {
        isError = true;
        tab.errorFields.push('Загрузите документ, указанный в поле "Документ на право подписи уполномоченного лица со стороны Грантополучателя"');
      }

      if (values.directorPositionRod === application.directorPosition) {
        isError = true;
        tab.errorFields.push('Должность лица, уполномоченного на право подписи должна быть в родительном падеже');
      }

      if (values.directorFullNameRod === application.directorFullName) {
        isError = true;
        tab.errorFields.push('ФИО лица, уполномоченного на право подписи должно быть в родительном падеже');
      }

      if (values.workType === 'workTypeNIOKR' && isEmpty(values.sampleType)) {
        isError = true;
        tab.errorFields.push('Укажите какой образец(-цы) должен(-ны) быть разработан(-ы)');
      }
    }

    if (tab.name === 'bank') {
      if (isEmpty(values.ogrn)) {
        isError = true;
        tab.errorFields.push('Укажите ОГРН');
      }
      if (isEmpty(values.inn)) {
        isError = true;
        tab.errorFields.push('Укажите ИНН');
      }
      if (isEmpty(values.kpp)) {
        isError = true;
        tab.errorFields.push('Укажите КПП');
      }
      if (isEmpty(values.urAddress)) {
        isError = true;
        tab.errorFields.push('Укажите юридический адрес');
      }
      if (isEmpty(values.poluchatel)) {
        isError = true;
        tab.errorFields.push('Укажите получателя');
      }
      if (isEmpty(values.bank)) {
        isError = true;
        tab.errorFields.push('Укажите название банка');
      }


      if (isEmpty(values.ks)) {
        isError = true;
        tab.errorFields.push('Укажите корреспондентский счет');
      }
      if (isEmpty(values.biq)) {
        isError = true;
        tab.errorFields.push('Укажите БИК');
      }
      if (isEmpty(values.rs)) {
        isError = true;
        tab.errorFields.push('Укажите расчетный счет');
      }
    }

    if (tab.name === 'tz') {
      if (isEmpty(values.tz_terms_definitions)) {
        isError = true;
        tab.errorFields.push('Укажите термины и определения');
      }
    }

    if (tab.name === 'smeta') {
      for (const year of years) {
        const total = getTotalByYear(application, year);

        if (isNaN(total) || total === 0) {
          continue;
        }

        let fieldsTotal = 0;

        smetaFields.forEach((field) => {
          fieldsTotal += values.smeta?.[`${field}${year}`] || 0;
        });

        if (total !== fieldsTotal) {
          tab.errorFields.push(`Сумма сметы в году ${year} не соответствует сумме полей`);
        }
      }

      if (tab.errorFields.length > 0) {
        isError = true;
      }
    }
  }

  return { isError, tabs };
};
